











































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import SMSPackagePO from "@/store/entities/messageinfo/smspackagepo";
import Util from "@/lib/util";

@Component({
  components: {},
})
export default class EditSMSPackage extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  smspackagepo: SMSPackagePO = new SMSPackagePO();
  loading: boolean = false;
  create() { }
  async created() { }
  //保存
  save() {
    (this.$refs.itemForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        await this.$store
          .dispatch({
            type: "smspackage/update",
            data: this.smspackagepo,
          })
          .catch((err) => {
            this.loading = false;
          });
        this.loading = false;
        (this.$refs.itemForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.itemForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.smspackagepo = Util.extend(true, {}, this.$store.state.smspackage.smsPackageItems);
    }
  }
  itemRule = {
    num: [
      {
        required: true,
        type: "number",
        message: this.L("FieldIsRequired"),
        trigger: "blur",
      },
    ],
    totalAmmount: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    effectiveTime: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    name: [
      {
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };
  data() {
    return {
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
          isDisabled: node.type == 1 ? true : false,
        };
      },
    };
  }
}
